// extracted by mini-css-extract-plugin
module.exports = {"container":"PurchaseCard_container__2lNU_","panel":"PurchaseCard_panel____XGY","title":"PurchaseCard_title__MAtAz"};